import { ExperimentsAction, ExperimentsTableDataState } from 'modules/experiments/types';
import { ActionTypes } from 'modules/experiments/ducks/actionTypes';

export const initialExperimentsTableDataState: ExperimentsTableDataState = {
  items: {},
  loading: false,
  error: false,
};

export const experimentsTableDataReducer = (
  state = initialExperimentsTableDataState,
  action?: ExperimentsAction,
) => {
  switch (action?.type) {
    case ActionTypes.FETCH_TABLE_DATA_REQUEST:
      return {
        ...state,
        error: false,
        loading: true,
      };

    case ActionTypes.FETCH_TABLE_DATA_RESPONSE: {
      const items = (action?.payload as ExperimentsTableDataState['items']) || state.items;

      return {
        items,
        error: false,
        loading: false,
      };
    }

    case ActionTypes.FETCH_TABLE_DATA_ERROR:
      return {
        ...state,
        error: true,
        loading: false,
      };
    default:
      return state;
  }
};
